import React, { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

export { Field, Input, Select, Card, Btn } from "@/pages/epbcs/common";

export const fmtN = (n, d = 0) =>
  (n === null || n === undefined || Number.isNaN(Number(n)))
    ? "—"
    : Number(n).toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });

export const Th = ({ children, className = "" }) => (
  <th className={`py-2 pr-3 text-left text-[10px] uppercase tracking-[0.15em] font-bold text-slate-500 ${className}`}>{children}</th>
);

const TONES = {
  open: "bg-blue-50 text-blue-700 border-blue-200",
  scheduled: "bg-amber-50 text-amber-700 border-amber-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  cancelled: "bg-slate-100 text-slate-500 border-slate-200",
  nominated: "bg-slate-100 text-slate-600 border-slate-200",
  in_transit: "bg-amber-50 text-amber-700 border-amber-200",
  delivered: "bg-blue-50 text-blue-700 border-blue-200",
  reconciled: "bg-emerald-50 text-emerald-700 border-emerald-200",
  matched: "bg-emerald-50 text-emerald-700 border-emerald-200",
  exception: "bg-red-50 text-red-700 border-red-200",
  missing_ticket: "bg-amber-50 text-amber-700 border-amber-200",
  buy: "bg-emerald-50 text-emerald-700 border-emerald-200",
  sell: "bg-red-50 text-red-700 border-red-200",
};

export const Badge = ({ v, testid }) => (
  <span data-testid={testid}
    className={`inline-block px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider border rounded-sm ${TONES[v] || "bg-slate-100 text-slate-600 border-slate-200"}`}>
    {String(v || "").replace(/_/g, " ")}
  </span>
);

export const KPI = ({ label, value, sub, testid, tone = "text-[#0B1E3F]" }) => (
  <div className="rounded-sm border border-slate-200 bg-white shadow-sm p-4" data-testid={testid}>
    <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-slate-500">{label}</div>
    <div className={`mt-1.5 text-2xl font-semibold tracking-tight ${tone}`}>{value}</div>
    {sub && <div className="mt-0.5 text-[11px] text-slate-500">{sub}</div>}
  </div>
);

export const useMasters = () => {
  const [masters, setMasters] = useState([]);
  const refresh = useCallback(
    () => api.get("/cam/masters").then((r) => setMasters(r.data || [])).catch(() => {}), []);
  useEffect(() => { refresh(); }, [refresh]);
  const byKind = (k) => masters.filter((m) => m.kind === k);
  return { masters, byKind, refresh };
};

export const MasterOptions = ({ items, placeholder = "Select…" }) => (
  <>
    <option value="">{placeholder}</option>
    {items.map((m) => <option key={m.code} value={m.code}>{m.code} — {m.name}</option>)}
  </>
);
